import { render } from 'react-dom';
import App from './app';

render(<App />, document.getElementById('__root'));